import React from "react";
import styled from "styled-components";

const Path = styled.path`
  fill: ${props => props.theme.primary};
`;

const Svg = styled.svg`
  width: 15.613px;
  height: 15.653px;
  @media (min-width: 1800px) {
    width: 21.54px;
    height: 21.6px;
  }
`;

const SearchIcon = () => {
  return (
    <Svg
      viewbox={
        window.screen.width < 1800 ? "0 0 15.613 15.653" : "0 0 21.539 21.596"
      }
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d={
          window.screen.width < 1800
            ? "M15.01,13.95l-3.97-3.69a6.314,6.314,0,1,0-1.1,1.025l4.05,3.765ZM1.5,6.25A4.75,4.75,0,1,1,6.25,11,4.754,4.754,0,0,1,1.5,6.25Z"
            : "M21.539,20.018l-5.7-5.3a9.061,9.061,0,1,0-1.578,1.471l5.812,5.4ZM2.152,8.969a6.816,6.816,0,1,1,6.816,6.816A6.822,6.822,0,0,1,2.152,8.969Z"
        }
        transform="translate(0.25 0.25)"
      />
    </Svg>
  );
};

export default SearchIcon;
